import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Объединяет классы с помощью clsx и разрешает конфликты Tailwind с помощью twMerge
 *
 * @example
 * cn("px-4 py-2", "bg-blue-500", "text-white hover:bg-blue-600")
 * cn("p-4", condition && "bg-red-100", isActive && "border-2 border-red-500")
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// ────────────────────────────────────────────────
// Дополнительные полезные утилиты (часто кладут в этот же файл)
// ────────────────────────────────────────────────

/**
 * Простая проверка, является ли значение "truthy" (удобно в шаблонах)
 */
export function isTruthy<T>(value: T | null | undefined | false | 0 | ""): value is T {
  return !!value;
}

/**
 * Условный класс (альтернатива ternary внутри cn)
 *
 * @example
 * conditionalClass(isOpen, "opacity-100", "opacity-0 pointer-events-none")
 */
export function conditionalClass(
  condition: boolean | undefined | null,
  trueClass: ClassValue,
  falseClass: ClassValue = "",
): ClassValue {
  return condition ? trueClass : falseClass;
}

/**
 * Часто используемая комбинация: скрыть элемент визуально, но оставить в DOM
 */
export const srOnly = "sr-only" as const;

/**
 * Тип для компонентов, которые принимают className
 */
export type WithClassName<P = {}> = P & {
  className?: ClassValue;
};

export default cn;